import { Lightning, Confetti } from "@phosphor-icons/react";
import { SectionShell, Panel } from "../Primitives";
import { Mascot } from "../Mascot";
import { MOTION } from "@/data/designTokens";

const PRINCIPLES = [
  { t: "Purposeful", d: "Motion guides attention and explains change — never noise." },
  { t: "Gentle springs", d: "A soft overshoot (bounce easing) feels alive, not bouncy or chaotic." },
  { t: "Celebrate wins", d: "Bigger, joyful animation is earned — saved for genuine progress." },
  { t: "Respect choice", d: "Honours prefers-reduced-motion with calm, static alternatives." },
];

export function MotionSection() {
  return (
    <SectionShell
      id="motion"
      eyebrow="Motion"
      eyebrowIcon={Lightning}
      title="Subtle, springy & celebratory"
      description="Animation should feel like a warm nod of encouragement. Quick and gentle for everyday taps; expressive and joyful for real achievements — and always optional."
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {MOTION.map((m) => (
          <div key={m.token} className="rounded-3xl border border-border bg-card p-6 shadow-soft">
            <p className="font-display text-3xl font-extrabold text-primary-strong">{m.ms}</p>
            <p className="mt-1 font-bold">{m.token}</p>
            <p className="text-sm font-semibold text-muted-foreground">{m.use}</p>
            <code className="mt-2 block font-mono text-xs font-semibold text-muted-foreground">{m.ease}</code>
          </div>
        ))}
      </div>

      <div className="mt-5 grid gap-5 lg:grid-cols-[1.1fr_0.9fr]">
        <Panel>
          <p className="mb-5 text-sm font-bold uppercase tracking-wider text-muted-foreground">Try it — hover &amp; press</p>
          <div className="flex flex-wrap items-center gap-5">
            <div className="cursor-pointer rounded-3xl border border-border bg-card p-6 shadow-soft transition-all duration-300 ease-bounce hover:-translate-y-2 hover:shadow-soft-lg">
              <p className="font-display font-extrabold">Lift card</p>
              <p className="text-sm font-semibold text-muted-foreground">hover me</p>
            </div>
            <button className="rounded-full bg-primary px-7 py-4 font-display font-bold text-primary-foreground shadow-glow transition-transform duration-150 active:scale-90">
              Press me
            </button>
            <div className="flex flex-col items-center gap-1">
              <Mascot size={64} />
              <span className="text-xs font-bold text-muted-foreground">idle float</span>
            </div>
            <span className="inline-flex animate-pop-in items-center gap-2 rounded-full bg-teal/15 px-4 py-2 font-bold text-teal-ink">
              <Confetti size={18} weight="fill" /> Well done!
            </span>
          </div>
        </Panel>

        <div className="grid gap-4 sm:grid-cols-2">
          {PRINCIPLES.map((p) => (
            <div key={p.t} className="rounded-3xl border border-border bg-card p-5 shadow-soft">
              <p className="font-display font-extrabold text-primary-strong">{p.t}</p>
              <p className="mt-1.5 text-sm font-medium leading-relaxed text-muted-foreground">{p.d}</p>
            </div>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}

export default MotionSection;
